import getLimits from "@irati/deals/utils/deal/limits"
import {Deal} from "@irati/types"
import {isOpenValueVoucherDeal} from "@irati/deals/helpers/redemption/deal"

import ProductTypes from "../../../../constants/productTypes"

export default function getDealType(deal: Deal) {
  const products = deal?.productConfig?.products || []
  if (!deal || products.length === 0) {
    return false
  }

  const attachedProductsCount = products.length
  const limits = getLimits(deal)
  const isOpenValue = isOpenValueVoucherDeal(deal)
  // Show Cinema UI just if all products attached are cinema products
  const isCinemaDeal = products.filter((p) => !!p.data?.cinemaMetadata?.enabled).length === products.length

  // Check redemption flow "type"
  if (isCinemaDeal) {
    return ProductTypes.CINEMA
  }
  if (isOpenValue) {
    return ProductTypes.OPEN_VALUE_PRODUCT
  }

  // Check limits on deal redemption
  if (limits.numProducts === 1 && attachedProductsCount > 1) {
    if (limits.numItems === 1) {
      // Choose product from drop down + no quantity selector (1 item per redemption)
      return ProductTypes.SINGLE_PRODUCT
    }
    // Choose product from drop down + quantity selector
    return ProductTypes.SINGLE_PRODUCT_QUANTITY
  }

  // Default UI, map through products and allow quantity selection
  return ProductTypes.MULTIPLE_PRODUCTS
}
